(function () {
  var rowsSeen = 0;

  function initAutoScroll(track) {
    var interval = parseInt(track.dataset.autoscrollInterval, 10) || 3000;
    var timer = null;
    var startDelay = null;
    // Stagger each row's first tick so multiple rows on the same page don't
    // all advance in lockstep - the 2nd row starts half an interval later
    // than the 1st, the 3rd a full interval later, and so on.
    var rowIndex = rowsSeen++;
    var stagger = (interval / 2) * rowIndex;

    function items() {
      return Array.prototype.slice.call(track.children);
    }

    function itemOffset(el) {
      return el.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    }

    function currentIndex(els) {
      var pos = track.scrollLeft;
      var closest = 0;
      var closestDiff = Infinity;
      els.forEach(function (el, i) {
        var diff = Math.abs(itemOffset(el) - pos);
        if (diff < closestDiff) {
          closestDiff = diff;
          closest = i;
        }
      });
      return closest;
    }

    function scrollNext() {
      var els = items();
      if (!els.length) return;
      var current = currentIndex(els);
      var wrapping = current >= els.length - 1;
      var next = wrapping ? 0 : current + 1;
      // Instant jump rather than behavior:'smooth' - smooth scrolling is
      // driven by the browser's animation/compositing pipeline, which can
      // stall (backgrounded tab, throttled rAF, etc.) and silently never
      // finish moving. CSS scroll-snap still gives the transition a soft
      // landing without depending on that pipeline actually running.
      track.scrollTo({ left: itemOffset(els[next]), behavior: 'auto' });
    }

    function start() {
      stop();
      timer = setInterval(scrollNext, interval);
    }
    function stop() {
      if (timer) clearInterval(timer);
      if (startDelay) clearTimeout(startDelay);
    }

    startDelay = setTimeout(start, stagger);
    track.addEventListener('mouseenter', stop);
    track.addEventListener('mouseleave', start);
    track.addEventListener('touchstart', stop, { passive: true });
    track.addEventListener('touchend', start, { passive: true });
  }

  function initScrollButtons() {
    document.querySelectorAll('[data-lushe-scroll]').forEach(function (button) {
      button.addEventListener('click', function () {
        var wrapper = button.closest('[class$="__wrapper"]');
        if (!wrapper) return;
        var track = wrapper.querySelector('[data-lushe-autoscroll], [class$="__grid"]');
        if (!track) return;
        var amount = track.clientWidth * 0.8;
        var direction = button.getAttribute('data-lushe-scroll') === 'prev' ? -1 : 1;
        track.scrollBy({ left: amount * direction, behavior: 'smooth' });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-lushe-autoscroll]').forEach(initAutoScroll);
    initScrollButtons();
  }

  document.addEventListener('DOMContentLoaded', init);
})();
